import { Link, useParams } from "react-router-dom";
import { NEW_TESTAMENT, OLD_TESTAMENT, slugify } from "../data/books";
import { BookOpen } from "lucide-react";

export default function PlaceholderChapter() {
  const { slug, chapter } = useParams();

  const all = [...NEW_TESTAMENT, ...OLD_TESTAMENT];
  const book =
    all.find((b) => slugify(b.name) === slug) ||
    // Fallback for short slugs (e.g. 'matthew' -> 'St. Matthew')
    all.find((b) =>
      slugify(b.name.replace(/^st\.?\s+/i, "")) === slug,
    );
  const bookName = book ? book.name : "Unknown Book";
  const isIntro = !chapter;
  const label = isIntro ? "Introduction" : `Chapter ${chapter}`;
  const sampleSlug = "matthew";
  const sampleLink = `/book/${sampleSlug}/chapter/1`;

  return (
    <div
      data-testid="placeholder-page"
      className="max-w-3xl mx-auto px-6 py-16"
    >
      <div className="parchment-card p-9 md:p-12 text-center fade-in">
        <BookOpen
          size={36}
          style={{ color: "var(--gold)", margin: "0 auto 1rem" }}
        />
        <div
          style={{
            fontFamily: "'IM Fell English SC', serif",
            letterSpacing: "0.3em",
            color: "var(--ink-muted)",
            fontSize: "0.85rem",
          }}
        >
          {bookName.toUpperCase()}
        </div>
        <h1
          style={{
            fontSize: "clamp(2rem, 4vw, 2.8rem)",
            margin: "0.4rem 0 0.7rem",
          }}
        >
          {label}
        </h1>
        <p
          style={{
            fontFamily: "'IM Fell English', serif",
            fontStyle: "italic",
            color: "var(--ink-soft)",
            fontSize: "1.1rem",
            maxWidth: "50ch",
            margin: "0 auto 1.6rem",
            lineHeight: 1.6,
          }}
        >
          This chapter has not yet been included in the revised reader. The
          full transcription is available in the live sample chapter below.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-3">
          <Link
            to={sampleLink}
            className="btn-ghost"
            style={{
              background: "var(--oxblood)",
              color: "var(--parchment-light)",
              borderColor: "var(--oxblood)",
            }}
            data-testid="goto-sample"
          >
            READ SAMPLE &mdash; MATTHEW 1 &rarr;
          </Link>
          <Link to="/" className="btn-ghost" data-testid="back-home">
            BACK TO INDEX
          </Link>
        </div>
      </div>
    </div>
  );
}
